import React from 'react'

const GreenButton = ({onClick, className, label}) => {
  return (
    <button className={`bg-[#49EA80] h-[40px] rounded-[10px] text-white font-poppins ${className ? className : null}`} onClick={onClick} >{label}</button>
  )
}

export default GreenButton;